import React, { useContext, useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import AssuranceContext from "../../context/index";
import withStyles from "@material-ui/core/styles/withStyles";
import DurationTabsComponent from "./duration";
import Policies from "../claims";
import Cards from "./cards";
import { Box, Hidden, Typography } from "@material-ui/core";
import { logout } from "../../helpers/utils";
import {
  buildSystemErrorMessage,
  getServiceCentreDetails,
} from "../../helpers/proposal";
import { getWebService } from "../../helpers/server";
import { ReducerUtils } from "../../constants/reducers";
import { useStyles } from "./dashboardStyles";
import {
  AUTHORIZATION,
  CLAIM_CLOSED_TEXT,
  CLAIM_INITIATED_TEXT,
  CLAIM_PARTIALLY_APPROVED_TEXT,
  CLAIM_REJECTED_TEXT,
  CLAIM_SETTLEMENT_COMPLETED_TEXT,
  CLAIM_STATUS_IN_PROGRESS_SLUG,
  CLAIM_SUBMITTED_TEXT,
  DEFAULT_TAB_INDEX,
  PARTNER_ID_MOBILE_STACK_DEMO,
  SOURCE_SERVICE_CENTRE,
} from "../../constants/index";
import { durationMapping } from "../../mapping";
import { Images } from "../../constants/images";

function DashboardComponent({
  classes: {
    backSolid,
    contentBox,
    loaderBox,
    main,
    mainContainer,
    logoGarantie,
    poweredBy,
    containerLogoGarantie,
  },
}) {
  const { state, dispatch } = useContext(AssuranceContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [value, setValue] = useState(DEFAULT_TAB_INDEX);

  useEffect(() => dispatchEvent(ReducerUtils.search.text, ""), []);
  useEffect(() => getDashboardCards(value), [value]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleChange = (event, newValue) => setValue(newValue);

  const cbError = ({ data: { error, error_msg } }) => {
    setIsLoaded(true);
    if (error === AUTHORIZATION) {
      logout();
      window.location.href = "/";
    } else {
      console.log(`error_msg = ${error_msg}`);
    }
  };

  const syncDashboardCardData = (cards) => {
    setIsLoaded(true);

    dispatchEvent(ReducerUtils.cards.list, cards);
  };

  const syncCardsAndClaims = (cards, claims) => {
    cards.forEach((card) => {
      claims.forEach((claim) => {
        if (card.values.indexOf(claim.status) > -1) {
          card.count++;
        } else if (
          card.slug === CLAIM_STATUS_IN_PROGRESS_SLUG &&
          [
            CLAIM_INITIATED_TEXT,
            CLAIM_SUBMITTED_TEXT,
            CLAIM_REJECTED_TEXT,
            CLAIM_SETTLEMENT_COMPLETED_TEXT,
            CLAIM_CLOSED_TEXT,
            CLAIM_PARTIALLY_APPROVED_TEXT,
          ].indexOf(claim.status) === -1
        ) {
          card.count++;
        }
      });
    });

    syncDashboardCardData([...cards]);
  };

  const fetchClaims = async ({ data: cards }) => {
    try {
      const url = `partners/claim?start=0&partner_id=${PARTNER_ID_MOBILE_STACK_DEMO}&date=${durationMapping[value]}&source=${SOURCE_SERVICE_CENTRE}`;
      const response = await getWebService(url);
      const {
        data: { claims },
      } = response.data;

      syncCardsAndClaims(cards, claims);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const getDashboardCards = async () => {
    try {
      const response = await getWebService("/data/cards.json");
      await fetchClaims(response.data);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  return (
    <>
      {isLoaded ? (
        <Box className={main}>
          <Box className={mainContainer}>
            <Box className={contentBox}>
              <>
                <Box className={backSolid}>
                  <Box>
                    <Typography variant={"h6"}>
                      <strong>{`Welcome ${getServiceCentreDetails(
                        "name"
                      )}`}</strong>
                    </Typography>
                  </Box>

                  <DurationTabsComponent
                    value={value}
                    handleChange={handleChange}
                  />

                  <Cards />

                  <Policies value={value} handleTabChange={handleChange} />
                </Box>
                <Box m={2}>
                  <Box justifyContent="center" className={poweredBy}>
                    <Typography variant={"body1"}>
                      <small>POWERED BY</small>
                    </Typography>
                  </Box>
                  <Box class={containerLogoGarantie}>
                    <img
                      src={Images.logo}
                      alt="Garantie"
                      className={logoGarantie}
                    />
                  </Box>
                </Box>
                <Hidden smDown>
                  <Box m={5}>&nbsp;</Box>
                </Hidden>
              </>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className={loaderBox}>
          <CircularProgress color={"secondary"} />
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(DashboardComponent);
